/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Profile Constants
 */

// Generic actions
export const GET_ALL_PROFILES = 'Profile/GET_ALL_PROFILES';
export const GET_PROFILE_BY_ID = 'Profile/GET_PROFILE_BY_ID';
export const CREATE_PROFILE = 'Profile/CREATE_PROFILE';
export const UPDATE_PROFILE = 'Profile/UPDATE_PROFILE';
export const DELETE_PROFILE_BY_ID = 'Profile/DELETE_PROFILE_BY_ID';
